import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import MenuIcon from '@material-ui/icons/Menu'
import {
  getProductsInCart,
  getProductsInFavorite,
  getUserRole,
} from '../../reducks/users/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { makeStyles } from '@material-ui/styles'
import { PERMISSIONS } from '../../constants/permissions'
import MenuBookIcon from '@material-ui/icons/MenuBook'

const useStyles = makeStyles((theme) => ({
  flexContents: {
    display: 'flex',
  },
  spanStyle: {
    display: 'inline-block',
    paddingRight: '20px',
    color: theme.palette.primary.main,
    fontSize: '16px',
  },
  manualLink: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    textDecoration: 'none',
    marginRight: '8px',
    '&:hover': {
      opacity: 0.7,
    },
  },
  manualText: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      marginLeft: '4px',
      fontSize: '16px',
    },
  },
}))

// カート/お気に入りの数量表示のみを担う純粋な表示コンポーネント。
// データ購読は Header の useUserCartFavoriteSync が一元的に行う。
const HeaderMenus = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const userRole = useSelector(getUserRole)
  const ProductsInCart = useSelector(getProductsInCart) || []
  const ProductsInFavorite = useSelector(getProductsInFavorite) || []

  const totalQuantity = ProductsInCart.reduce((accumulator, product) => {
    return accumulator + (product.quantity || 0)
  }, 0)

  return (
    <div className={classes.flexContents}>
      {userRole !== PERMISSIONS.VIEWER && (
        <div className={classes.flexContents}>
          <div
            className={classes.manualLink}
            onClick={() => dispatch(push('/notice/list?category=マニュアル'))}
          >
            <MenuBookIcon />
            <span className={classes.manualText}>
              マニュアル・ルールはこちら
            </span>
          </div>
          <IconButton onClick={() => dispatch(push('/cart'))}>
            <Badge
              badgeContent={totalQuantity}
              color="error"
              overlap="rectangular"
            >
              <ShoppingCartIcon />
            </Badge>
          </IconButton>
          <IconButton onClick={() => dispatch(push('/favorite'))}>
            <Badge
              badgeContent={ProductsInFavorite.length}
              color="error"
              overlap="rectangular"
            >
              <FavoriteBorderIcon />
            </Badge>
          </IconButton>
        </div>
      )}
      {userRole === PERMISSIONS.VIEWER && (
        <span className={classes.spanStyle}>Catalog</span>
      )}
      <IconButton
        aria-label="Menu Items"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={(e) => props.handleDrawerToggle(e, true)}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
    </div>
  )
}

export default HeaderMenus
